import { Action } from "../../../libs/redux/action";
import {
    CUSTOMER_PATCH_BUSINESS,
    CUSTOMER_PATCH_CONTACT,
    CUSTOMER_PATCH_NATURAL_PERSON,
    CUSTOMER_SET_RUC_HAS_LEGAL_REPRESENTATIVE,
} from "../constants";
import { CustomerState } from "../state";
import { CustomerBusinessParams } from "../../../containers/quotation-popup/types/quotation-popup";

export class CustomerSetRucHasLegalRepresentative extends Action<
    boolean,
    CustomerState
> {
    readonly type = CUSTOMER_SET_RUC_HAS_LEGAL_REPRESENTATIVE;
    reducer(state: CustomerState): CustomerState {
        return {
            ...state,
            rucHasLegalRepresentative: this.payload,
        };
    }
}

export class CustomerPatchBusiness extends Action<
    Partial<CustomerState["business"]>,
    CustomerState
> {
    readonly type = CUSTOMER_PATCH_BUSINESS;
    reducer(state: CustomerState): CustomerState {
        return {
            ...state,
            business: {
                ...state.business,
                ...this.payload,
            },
        };
    }
}

export class CustomerPatchNaturalPerson extends Action<
    Partial<CustomerBusinessParams>,
    CustomerState
> {
    readonly type = CUSTOMER_PATCH_NATURAL_PERSON;
    reducer(state: CustomerState): CustomerState {
        const {
            naturalName,
            naturalLastName,
            naturalMotherLastName,
            ...businessData
        } = this.payload;

        const isNaturalPerson = !!(
            naturalName &&
            naturalLastName &&
            naturalMotherLastName
        );

        return {
            ...state,
            business: {
                ...state.business,
                ...businessData,
            },
            naturalName,
            naturalLastName,
            naturalMotherLastName,
            isNaturalPerson,
        };
    }
}

export class CustomerPatchContact extends Action<
    Partial<CustomerState["contact"]>,
    CustomerState
> {
    readonly type = CUSTOMER_PATCH_CONTACT;
    reducer(state: CustomerState): CustomerState {
        return {
            ...state,
            contact: {
                ...state.contact,
                ...this.payload,
            },
        };
    }
}
